module.exports = __webpack_public_path__ + "assets/img/thumb-AIF-Social-Static-Ad.4cd900d0.jpg";